// the library has bug when taking parameter to transform in array item
var objectMapper = require('object-mapper');
export const getServiceOptionsMapper = (data: any) => objectMapper(data.shippingService.options, map);
export const getLTLServiceOptionsMapper = (data: any) => objectMapper(data, map);

const map = {
    "[].code": "[].optionCode",
    "[].name": "[].optionName"
}